import { useTranslation } from 'react-i18next';

import { ListingCard } from './listing-card';
import { localizedBoatTitle, localizedBoatType } from '../lib/boat-content';
import { formatPrice, localePath } from '../lib/format';
import type { Boat } from '@todo/core/boats';
import { useLocale } from '@todo/core/i18n/use-locale';

export function BoatCard({ boat }: { boat: Boat }) {
  const { t } = useTranslation();
  const { locale } = useLocale();

  const facts = [localizedBoatType(boat, locale), boat.year ? String(boat.year) : ''].filter(Boolean);

  return (
    <ListingCard
      href={localePath(locale, `boats/${boat.id}`)}
      imageUrl={boat.image_url}
      category={t('card.boat')}
      title={localizedBoatTitle(boat, locale)}
      facts={facts}
      price={
        boat.from_price != null
          ? `${t('card.from', { price: formatPrice(Number(boat.from_price), boat.currency, locale) })} ${t('boats.perDay')}`
          : null
      }
    />
  );
}
